/**
 * Video Play Button functionality
 * Adds custom play button overlay to WordPress video blocks
 */
(function() {
	'use strict';

	/**
	 * Initialize video play buttons
	 */
	function initVideoPlayButtons() {
		const videoWrappers = document.querySelectorAll('.evona-video-wrapper');

		videoWrappers.forEach(function(wrapper) {
			const video = wrapper.querySelector('video');
			const playButton = wrapper.querySelector('.evona-video-play-button');

			if (!video || !playButton) {
				return;
			}

			// Check if already initialized
			if (video.dataset.playButtonInitialized === 'true') {
				return;
			}

			// Mark as initialized
			video.dataset.playButtonInitialized = 'true';

			// Play video on button click; show native controls only after first play
			playButton.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				if (!video.hasAttribute('controls')) {
					video.setAttribute('controls', '');
				}
				video.play();
				wrapper.classList.add('video-playing');
				wrapper.classList.remove('video-paused');
			});

			// Update button state based on video events
			video.addEventListener('play', function() {
				wrapper.classList.add('video-playing');
				wrapper.classList.remove('video-paused');
			});

			video.addEventListener('pause', function() {
				wrapper.classList.add('video-paused');
				wrapper.classList.remove('video-playing');
			});

			video.addEventListener('ended', function() {
				wrapper.classList.add('video-paused');
				wrapper.classList.remove('video-playing');
			});

			// Initial state
			if (video.paused) {
				wrapper.classList.add('video-paused');
			} else {
				wrapper.classList.add('video-playing');
			}
		});
	}

	// Initialize on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initVideoPlayButtons);
	} else {
		initVideoPlayButtons();
	}

	// Re-initialize for dynamically loaded content (e.g., AJAX)
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('evona:contentLoaded', initVideoPlayButtons);
	}
})();
